import {COMMON, CONSTANT} from "../common.js";
const MEMBER = (function () {
    let modules = {};

    modules.daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    modules.daysInMonthLeapYear = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    modules.today = new Date();
    modules.targetDate = new Date(1970, 0, 1);

    const MALE = typeof MAN !== 'undefined' ? MAN : null;
    const FEMALE = typeof WOMAN !== 'undefined' ? WOMAN : null;
    const prefecturesName = typeof prefectures !== 'undefined' ? prefectures : [];
    const IS_TYPE_USER = (typeof TENANT_TYPE !== 'undefined' && typeof TYPE_USER !== 'undefined')
        ? TENANT_TYPE === TYPE_USER
        : false;

    const GENDER = {
        [MALE]: '男性',
        [FEMALE]: '女性',
    };

    $(".show-password, .hide-password").on('click', function() {
        let passwordInput = $('#password');
        let type = passwordInput.attr('type') === 'password' ? 'text' : 'password';
        passwordInput.attr('type', type);

        if ($(this).hasClass('hide-password')) {
            $(this).parent().find(".show-password").show();
            $(this).parent().find(".hide-password").hide();
        } else {
            $(this).parent().find(".hide-password").show();
            $(this).parent().find(".show-password").hide();
        }
    });

    $(".show-password-confirm, .hide-password-confirm").on('click', function() {
        let passwordInput = $('#confirm-password');
        let type = passwordInput.attr('type') === 'password' ? 'text' : 'password';
        passwordInput.attr('type', type);

        if ($(this).hasClass('hide-password-confirm')) {
            $(this).parent().find(".show-password-confirm").show();
            $(this).parent().find(".hide-password-confirm").hide();
        } else {
            $(this).parent().find(".hide-password-confirm").show();
            $(this).parent().find(".show-password-confirm").hide();
        }
    });

    $(document).on('click', '#show-password-confirmation', function () {
        let element = $('#password_confirmation');
        let inputType = element.attr('type');
        if (inputType === 'password') {
            element.attr('type', 'text');
        } else {
            element.attr('type', 'password');
        }
        $(this).toggleClass('fa-eye-slash').toggleClass('fa-eye');
    });

    $('#agree-collect-personal-information-checkbox').change(function() {
        checkEnableBtnUploadIDCard();
    });

    function checkEnableBtnUploadIDCard() {
        if ($('#agree-collect-personal-information-checkbox').is(':checked')) {
            $('#btn-upload-id-card').prop('disabled', false);
            $('#btn-upload-id-card').removeClass('btn-next-step-bid-disable');
        } else {
            $('#btn-upload-id-card').prop('disabled', true);
            $('#btn-upload-id-card').addClass('btn-next-step-bid-disable');
        }
    }

    modules.callAjaxCheckValidationPerson = function () {
        let data = $('#form-member-person').serializeArray();

        COMMON.callApi(CONSTANT.URL_CHECK_VALIDATION_MEMBER_PERSON, 'POST', 'JSON', data)
            .then(res => {
                $.each(data, function (index, val) {
                    $(`.confirm-person #${val.name.replace(/_/g, "-")}`).empty().append(val.value);
                });
                $('.content.person-info').addClass('d-none');
                $('.content.confirm-person').removeClass('d-none');
            })
            .catch(err => {
                $('.person-info .error').empty();
                if (err.status === 422) {
                    modules.showError(err.responseJSON.errors.password, '.err-password', '#password');
                    modules.showError(err.responseJSON.errors.confirm_password, '.err-confirm-password', '#confirm-password');
                    modules.showError(err.responseJSON.errors.name, '.err-name', '#name');
                    modules.showError(err.responseJSON.errors.katakana_name, '.err-katakana-name', '#katakana-name');
                    modules.showError(err.responseJSON.errors.company_katakana_name, '.err-company-katakana-name', '#company-katakana-name');
                    modules.showError(err.responseJSON.errors.phone, '.err-phone', '#phone');
                    modules.showError(err.responseJSON.errors.postal_code, '.err-postal-code', '#postal-code');
                    modules.showError(err.responseJSON.errors.prefecture_name, '.err-prefecture-name', '#prefecture-name');
                    modules.showError(err.responseJSON.errors.street_name, '.err-street-name', '#street-name');
                    modules.showError(err.responseJSON.errors.building_name, '.err-building-name', '#building-name');
                    modules.focusError(err.responseJSON.errors);
                }
            });
    }

    modules.callAjaxCheckValidationUpdatePerson = function () {
        let data = $('#form-member-person').serializeArray();

        COMMON.callApi(CONSTANT.URL_CHECK_VALIDATION_MEMBER_UPDATE_PERSON, 'POST', 'JSON', data)
            .then(res => {
                $.each(data, function (index, val) {
                    if (val.name === 'gender') {
                        console.log(GENDER)
                        val.value = GENDER[val.value] || '';
                    }
                    if (val.name === 'prefecture_name') {
                        val.value = getPrefectureName(prefecturesName, val.value);
                    }
                    $(`.confirm-person #${val.name.replace(/_/g, "-")}`).empty().append(val.value);
                });
                let isMailLive = $('.confirm-person #is-mail-live');
                isMailLive.text() ? isMailLive.text('希望する') : isMailLive.text('希望しない');
                $('.content.person-info').addClass('d-none');
                $('.content.confirm-person').removeClass('d-none');
            })
            .catch(err => {
                $('.person-info .error').empty();
                if (err.status === 422) {
                    modules.showError(err.responseJSON.errors.name, '.err-name', '#member-name');
                    modules.showError(err.responseJSON.errors.katakana_name, '.err-katakana-name', '#member-katakana-name');
                    if (!IS_TYPE_USER) {
                        modules.showError(err.responseJSON.errors.company_name, '.err-company-name', '#member-company-name');
                    }
                    modules.showError(err.responseJSON.errors.company_katakana_name, '.err-company-katakana-name', '#member-company-katakana-name');
                    modules.showError(err.responseJSON.errors.phone, '.err-phone', '#member-phone');
                    modules.showError(err.responseJSON.errors.gender, '.err-gender');
                    modules.showError(err.responseJSON.errors.postal_code, '.err-postal-code', '#member-postal-code');
                    modules.showError(err.responseJSON.errors.prefecture_name, '.err-prefecture-name', '#member-prefecture-name');
                    modules.showError(err.responseJSON.errors.street_name, '.err-street-name', '#member-street-name');
                    modules.showError(err.responseJSON.errors.building_name, '.err-building-name', '#member-building-name');
                    modules.focusError(err.responseJSON.errors);
                }
            });
    }

    modules.callAjaxCheckValidationBidPerson = function () {
        let data = new FormData($('#form-bid-personal')[0])

        COMMON.callApi(CONSTANT.URL_CHECK_VALIDATION_BID_MEMBER_PERSONAL, 'POST', null, data)
            .then(res => {
                $('#form-bid-personal .error').empty();
                modules.showLoadingBeforeSubmit();
                $('#form-bid-personal').submit();
            })
            .catch(err => {
                $('#form-bid-personal .error').empty();
                if (err.status === 422) {
                    modules.showError(err.responseJSON.errors.img_front, '.err-img-front', '#img-front');
                    modules.showError(err.responseJSON.errors.img_back, '.err-img-back', '#img-back');
                    modules.showError(err.responseJSON.errors.agree_collect_personal_information, '.err-agree-collect-personal-information-checkbox', '#agree-collect-personal-information-checkbox');
                    modules.focusError(err.responseJSON.errors);
                }
            })
    }

    modules.showLoadingBeforeSubmit = function () {
        if ($('#loading-overlay').length === 0) {
            $('body').append(`
            <div id="loading-overlay" style="
                position: fixed;
                top: 0; left: 0; width: 100%; height: 100%;
                background: rgba(255, 255, 255, 0.8);
                z-index: 9999;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                font-weight: bold;
                color: #333;
            ">
                <div>確認までにお時間を頂戴することがございます...</div>
                <div class="spinner" style="
                    margin-top: 20px;
                    width: 40px;
                    height: 40px;
                    border: 4px solid #ccc;
                    border-top: 4px solid #333;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                "></div>
            </div>

            <style>
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            </style>
        `);
        }
    };

    modules.showError = function (err, element, hover) {
        if (err) {
            $(hover).addClass('hover-error')
            $(element).empty().append(err.shift());
        } else {
            $(hover).removeClass('hover-error')
            $(element).empty().append('')
        }
    }

    modules.focusError = function (err) {
        if (err) {
            let form = $('#form-bid-personal .hover-error, #form-member-person .hover-error')
            let id = '#' + form.attr('id');
            console.log('hb', id)
            $([document.documentElement, document.body]).animate({
                scrollTop: $(id).offset().top-100
            }, 500);
            $(id).trigger('focus');
        }
    }

    modules.formatIndex = function (errors) {
        for (let key in errors) {
            if (key.includes('.')) {
                let newKey = key.replace(/\./g, "_");
                errors[newKey] = errors[key];
                delete errors[key];
            }
        }
        return errors;
    }

    modules.setDate = function (date) {
        modules.setDays(date.getMonth());
        $("#select-day").val(date.getDate());
        $("#select-month").val(date.getMonth());
        $("#select-year").val(date.getFullYear());
    }

    modules.setDays = function (monthIndex) {
        let optionCount = $('#select-day option').length - 1;
        let daysCount = modules.daysInMonth[monthIndex];

        if (($('#select-year').val() % 4) == 0) {
            daysCount = modules.daysInMonthLeapYear[monthIndex];
        }

        if (optionCount < daysCount) {
            for (let i = optionCount; i < daysCount; i++) {
                $('#select-day')
                    .append($("<option></option>")
                        .attr("value", i + 1)
                        .text(`${i + 1}日`));
            }
        } else {
            for (let i = daysCount; i < optionCount; i++) {
                let optionItem = '#select-day option[value=' + (i + 1) + ']';
                $(optionItem).remove();
            }
        }
    }

    modules.setYears = function (val) {
        let year = modules.today.getFullYear();
        for (let i = 0; i < val; i++) {
            $('#select-year')
                .append($("<option></option>")
                    .attr("value", year - i)
                    .text(`${year - i}年`));
        }
    }

    modules.formatBirthdate = function () {
        let year = $('#form-member-person select[name="year"]').val(),
            month = parseInt($('#form-member-person select[name="month"]').val()) + 1,
            day = $('#form-member-person select[name="day"]').val();

        $('#form-member-person input[name="birthdate"]').val(`${year}/${month}/${day}`);
    }

    return modules;
})(window.jQuery, window, document);

$(document).ready(function () {
    MEMBER.setYears(100);

    $(document).on('change', '#select-month', function () {
        let monthIndex = $("#select-month").val();
        MEMBER.setDays(monthIndex);
    })

    $(document).on('change', '#select-year', function () {
        let monthIndex = $("#select-month").val();
        MEMBER.setDays(monthIndex);
    })

    $(document).on('click', '.type', function () {
        let type = $(this).val();
        if (type == 1) {
            window.location.href = CONSTANT.URL_CREATE_MEMBER_PERSON;
        }
    });

    $(document).on('click', '.verify-email .btn-resend', function () {
        let urlCurrent = new URL(window.location.href);
        urlCurrent.searchParams.set('sendMail', 1);
        window.location.href = urlCurrent.href;
    });

    $(document).on('input', '.just-number', function () {
        this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
    })

    $(document).on('click', '.btn-member.person', function (event) {
        let selectedGender = $('input[name="gender"]:checked').val();
        if(selectedGender === '1') {
            $('#text-gender').html('男性');
        } else {
            $('#text-gender').html('女性');
        }
        event.preventDefault();
        MEMBER.formatBirthdate();
        MEMBER.callAjaxCheckValidationPerson();
    })

    $(document).on('click', '.btn-update-member-detail', function (event) {
        event.preventDefault();
        MEMBER.formatBirthdate();
        MEMBER.callAjaxCheckValidationUpdatePerson();
    })

    $(document).on('click', '.confirm-person .btn-back', function () {
        $('.content.person-info').removeClass('d-none');
        $('.content.confirm-person').addClass('d-none');
    })

    $(document).on('click', '.confirm-person .btn-next-step, .btn-confirm-update-member-detail', function () {
        $('#form-member-person').submit();
    })

    $(document).on('click', '.btn-menu', function () {
        $('.sidebar').addClass('active');
        $('.btn-menu').css('visibility', 'hidden');
    });

    $(document).on('click', '.btn-close-sidebar', function () {
        $('.sidebar').removeClass('active');
        $('.btn-menu').css('visibility', 'visible');
    });

    $(document).on('click', '#btn-get-image-front', function () {
        $('#get-image-front').click();
    });

    $("#get-image-front").on("change", function () {
        const file = this.files[0];
        if (file) {
            $('#preview-img-front').attr('src', URL.createObjectURL(file));
        }
    });

    $(document).on('click', '#btn-get-image-back', function () {
        $('#get-image-back').click();
    });

    $("#get-image-back").on("change", function () {
        const file = this.files[0];
        if (file) {
            $('#preview-img-back').attr('src', URL.createObjectURL(file));
        }
    });

    $(document).on('click', '.next-step-bid', function (event) {
        event.preventDefault();
        MEMBER.callAjaxCheckValidationBidPerson()
    })

    COMMON.validateSizeFileImage('#get-image-front', ['表面は10MB以内のJPG・HEIC・TIFF・JPEG・PNGにしてください', '.err-img-front', '#img-front'])
    COMMON.validateSizeFileImage('#get-image-back', ['表面は10MB以内のJPG・HEIC・TIFF・JPEG・PNGにしてください', '.err-img-back', '#img-back'])

    $(document).on('click', '.btn-reset-password', function (event) {
        event.preventDefault();
        $('#form-member-reset-password').submit();
    })
    //show_bids_finish
    function nl2br (str, is_xhtml) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        let breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

    $('.product-detail').on('click', function (e) {
        let product = $(this).data('product');
        let modal = $('#modal-preview-product');
        modal.find('#product-name').text(product.name);
        modal.find('#product-cate-name').text($(this).data('product-cate'));
        modal.find('#product-id').text(product.id);
        modal.find('#product-name-detail').text(product.name);
        modal.find('#product-note').html(nl2br(product.note));
        modal.find('#product-size').html(nl2br(product.size));

        if  (product.description !== '') {
            modal.find('.description-box').show();
            modal.find('#product-description').html(nl2br(product.description));
        } else {
            modal.find('.description-box').hide();
        }

        let t = new Date(product.updated_at).toLocaleString("en-US", {timeZone: "Asia/Tokyo"});
        let d = new Date(t);
        let date;
        date = d.getFullYear() + "/" + ('0' + (d.getMonth() + 1)).slice(-2) + "/" + ('0' + d.getDate()).slice(-2) + " " +
            ('0' + d.getHours()).slice(-2) + ":" + ('0' + d.getMinutes()).slice(-2);
        modal.find('#product-bid-success-date').text(date);

        modal.find('#product-bid-amount').text(product.amount.toLocaleString('en'));

        //image
        let images = $(this).data('product-image');
        let defaultImg = $(this).data('image-default');
        $('#product-image-box').empty();
        images.forEach(function (image) {
            let element = '<div class="col-sm-3 mb-3">' +
                '<img class="file-upload-image-small" width="100%" height="100%" src="' + image + '" alt="your image"/>' +
                '</div>';

            $('#product-image-box').append(element);
        });

        let imgs = document.getElementsByClassName("file-upload-image-small");
        for (const img of imgs) {
            img.addEventListener("error", function(event) {
                event.target.src = defaultImg;
                event.onerror = null;
            });
        }
        modal.modal('show');
    });

    $(document).on('click', '.btn-postal-code-render', function () {
        let postalCode = $('#member-postal-code').val();
        let data = {
            "postalCode": postalCode,
        };

        if (postalCode) {
            COMMON.callApi(CONSTANT.URL_GET_ADDRESS, 'POST', 'JSON', data)
                .then(res => {
                    if (res.status === 200 && res.results) {
                        console.log($('#street-name').val())
                        let street_name = res.results[0].address2 + ' ' + res.results[0].address3;

                        $("#prefecture-name").val(res.results[0].address1).change();
                        $('#member-street-name').val(street_name);
                        $('.err-postal-code').html('');
                    } else {
                        $('.err-postal-code').html('ご郵便番号が確認できません。');
                        $('#prefecture-name').val('');
                        $('#street-name').val('');
                    }
                })
                .catch(err => {
                    console.log(err);
                })
        } else {
            $('.err-postal-code').html('郵便番号を入力していください 。');
        }
    });

    $(document).on('click', '.btn-render-postal-code', function () {
        let postalCode = $('#postal-code').val();
        let data = {
            "postalCode": postalCode,
        };
        $('.err-postal-code').text('');

        COMMON.callApi(CONSTANT.URL_GET_ADDRESS, 'POST', 'JSON', data)
            .then(res => {
                if (res.status === 200 && res.results) {
                    let prefecture_name = res.results[0].address1;
                    let street_name = res.results[0].address2 + ' ' + res.results[0].address3;

                    $("#prefecture-name").val(prefecture_name).change().removeClass('hover-error');
                    $('#street-name').val(street_name).removeClass('hover-error');
                    $('#building-name').removeClass('hover-error');
                    $('.err-prefecture-name').text('');
                    $('.err-street-name').text('');
                    $('.err-building-name').text('');
                } else {
                    $('#prefecture-name').val('');
                    $('#street-name').val('');
                    $('#building-name').val('');
                    if (res.status === 400 && res.results == null) {
                        COMMON.showError([
                            'ご郵便番号が確認できません。'
                        ], '.err-postal-code');
                    }
                }
            })
            .catch(err => {
                console.log(err);
            })

    });

    $(document).on('click', '.btn-back-member-detail', function () {
        $('.content.person-info').removeClass('d-none');
        $('.content.confirm-person').addClass('d-none');
    });

    $(document).on('input', '#member-postal-code, input[name*="phone"], input[name*="fax"]', function (event) {
        return isNumber(event);
    })
});

function isNumber(evt) {
    let input = evt.target;
    let value = input.value;

    input.value = value.replace(/\D/g, '');
}

function getPrefectureName(prefectures, prefCode) {
    const prefecture = prefectures.find(pref => pref.prefCode === Number(prefCode));
    return prefecture ? prefecture.prefName : prefCode;
}

function clearDateSelection() {
    $("#select-day").val('');
    $("#select-month").val('');
    $("#select-year").val('');
}
